import {Component, NgModule, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DirectivesModule} from '../../../directives/directives.module';
import {AngularSvgIconModule} from 'angular-svg-icon';

@Component({
    selector: 'app-usp',
    templateUrl: './usp.component.html',
    styleUrls: ['./usp.component.scss']
})
export class UspPluginComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}

@NgModule({
    declarations: [
        UspPluginComponent,
    ],
    imports: [
        CommonModule,
        DirectivesModule,
        AngularSvgIconModule
    ]
})

export class UspPluginModule {
}
